// Autogenerated file
export const bidCalculationStatusesEnum = {
    NoCoordinates: "NoCoordinates",
    NoActivity: "NoActivity",
    InProgress: "InProgress",
    HasPlanMileageDeviation: "HasPlanMileageDeviation",
};
export const bidCalculationStatuses = [
    { label: "Не учтена", value: "NoCoordinates" },
    { label: "Не учтена", value: "NoActivity" },
    { label: "В обработке", value: "InProgress" },
    { label: "Не учтена", value: "HasPlanMileageDeviation" },
];
